

















































import Vue from 'vue';
import { OpportunityMembershipStatus, Opportunity, OpportunityMember } from '@/models/opportunities';
import { getGeekDetails } from '@/shared';

export default Vue.extend({
  name: 'OpportunityCandidates',
  props: {
    opportunity: Object as () => Opportunity,
  },
  data() {
    return {
      opportunityMembershipStatus: OpportunityMembershipStatus,
    };
  },
  methods: {
    getMembershipStatusIcon(status: string): string {
      const membershipStatusIconMap: { [key: string]: string } = {
        [OpportunityMembershipStatus.Rejected]: 'reject',
        [OpportunityMembershipStatus.Accepted]: 'accept',
        [OpportunityMembershipStatus.Waiting]: 'pending',
      };
      return membershipStatusIconMap[status];
    },
    approveCandidate(candidate: OpportunityMember) {
      this.$emit('approveCandidate', candidate.geek);
    },
    rejectCandidate(candidate: OpportunityMember) {
      this.$emit('rejectCandidate', candidate.geek);
    },
    getGeekDetails,
  },
});
